import * as React from 'react';

export const Divider: React.FC = () => (
  <hr className="h-0 border-grey-200 border-0 border-t" />
);
